import React from "react";
import { Car, Radio, Zap, GraduationCap, Cpu, Globe2, Handshake, MapPin, ShieldCheck } from "lucide-react";
import { useSiteContent } from "../data/content";

const ICONS = { Car, Radio, Zap, GraduationCap, Cpu, Globe2, Handshake, MapPin, ShieldCheck };

export function Industries() {
  const content = useSiteContent();
  const ui = content.ui.industries;
  return (
    <section id="branchen" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div className="max-w-2xl">
            <span className="text-[12px] font-medium tracking-[0.2em] uppercase text-teal-700">
              {ui.eyebrow}
            </span>
            <h2 className="mt-4 text-4xl lg:text-5xl font-semibold tracking-[-0.02em] text-[#0B1F3A] leading-[1.1]">
              {ui.titleLine1}
              <br />
              {ui.titleLine2}
            </h2>
          </div>
          <div className="text-sm text-slate-500 max-w-sm">{ui.lead}</div>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {content.industries.map((ind) => {
            const Icon = ICONS[ind.icon];
            return (
              <div
                key={ind.title}
                className="group relative rounded-2xl border border-slate-200 p-8 hover:bg-[#0B1F3A] hover:border-[#0B1F3A] transition-colors duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-teal-50 group-hover:bg-teal-500/15 text-teal-700 group-hover:text-teal-300 flex items-center justify-center transition-colors duration-300">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="mt-6 text-xl font-semibold text-[#0B1F3A] group-hover:text-white transition-colors duration-300">
                  {ind.title}
                </h3>
                <p className="mt-3 text-slate-600 group-hover:text-slate-300 leading-relaxed transition-colors duration-300">
                  {ind.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function Differentiators() {
  const content = useSiteContent();
  const ui = content.ui.differentiators;
  return (
    <section id="warum" className="py-24 lg:py-32 bg-slate-50/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-[12px] font-medium tracking-[0.2em] uppercase text-teal-700">
            {ui.eyebrow}
          </span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-semibold tracking-[-0.02em] text-[#0B1F3A] leading-[1.1]">
            {ui.titleLine1}
            <br />
            <span className="text-slate-500">{ui.titleLine2}</span>
          </h2>
        </div>
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 rounded-2xl overflow-hidden border border-slate-200">
          {content.differentiators.map((d) => {
            const Icon = ICONS[d.icon];
            return (
              <div key={d.title} className="bg-white p-8 hover:bg-slate-50 transition-colors duration-200">
                <div className="w-11 h-11 rounded-lg bg-[#0B1F3A] text-white flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-5 text-lg font-semibold text-[#0B1F3A]">{d.title}</h3>
                <p className="mt-2 text-[15px] text-slate-600 leading-relaxed">{d.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
